import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { useDropzone } from 'react-dropzone'
import EditIcon from '@mui/icons-material/Edit';
import Modal from "./Modal";

const staticResponse = [
  {
    "id": 101,
    "serialNo": 101,
    "uniqueId": "ABC132132",
    "fullName": "भीमा तुकाराम आखाडे",
    "fatherName": "तुकाराम आखाडे",
    "roomNo": "गडगे",
    "age": 22,
    "sex": "महिला",
    "fileName": "AbcFile.pdf"
  },
  {
    "id": 102,
    "serialNo": 102,
    "uniqueId": "ABC132132",
    "fullName": "भीमा तुकाराम आखाडे",
    "fatherName": "तुकाराम आखाडे",
    "roomNo": "गडगे",
    "age": 22,
    "sex": "महिला",
    "fileName": "AbcFile.pdf"
  }
]
const Upload = () => {

  const [uploadTriggerdOnce, setUploadTriggerdOnce] = useState(false)
  const [tableData, setTableData] = useState([])
  // const [tableData, setTableData] = useState(staticResponse)
  const [tableHeaders, setTableHeaders] = useState([])
  const [editData, setEditData] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)


  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader()

      reader.onabort = () => console.log('file reading was aborted')
      reader.onerror = () => console.log('file reading has failed')
      reader.onload = () => {
        // Do whatever you want with the file contents
        const binaryStr = reader.result
        // const parsed = String.fromCharCode.apply(null, new Uint8Array(binaryStr))
        // const parsed = JSON.parse(binaryStr.toString())

        // const x = new Uint8Array(binaryStr)
        // console.log(Array.from(x))
        setTableData(staticResponse)
      }
      reader.readAsArrayBuffer(file)
    })

  }, [])

  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({ onDrop })

  useEffect(() => {
    if (!isEmpty(tableData)) {
      const headers = Object.keys(tableData[0])
      setTableHeaders(headers)
    }
  }, [tableData])

  const handleEditClick = data => {
    setEditData(data)
    setModalOpen(true)
  }

  const handleEditOk = data => {
    setModalOpen(false)
    setTableData(tbData => {

      return tbData.map((dataObj) => {

        if (dataObj.id === data.id) {
          return data
        }
        return dataObj
      })
    })
  }

  const handleEditCancel = data => {
    setModalOpen(false)
  }

  return (
    <Box className={`w-full min-h-[400px] pt-10 justify-center flex-col items-center`}>
      <Box className={`w-full mx-auto text-center`}>
        <Box className={`text-center h-1/2 mb-5`}>
          <div {...getRootProps()}>
            <input {...getInputProps()} accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document" />
            <div
              className={`w-fit mx-auto p-[10px] rounded-lg shadow-[0_0_5px_0px_#969494]`}
            >Drag 'n' drop some files here, or click to select files</div>
          </div>
        </Box>
        <Box className={`table-section w-fit xs:w-full h-full mx-auto`}>
          {
            (isEmpty(tableData) ?
              <Box
                className={`w-full h-full border-[1px_solid_#000]`}
              >
                {
                  !uploadTriggerdOnce ? 'Please upload a file to fetch data' : 'No data found'
                }
              </Box> : (
                isEmpty(tableHeaders)) ?
                <Box
                  className={`w-full xs:max-sm:!w-[98vw] h-full border-[1px_solid_#000]`}
                >
                  'No data found'
                </Box> :
                <Box className={`table xs:max-sm:w-[98vw]`}>
                  <TableContainer component={Paper} className={`max-lg:!w-[90vw] lg:!w-[120ch]  relative`}>
                    <Table aria-label="simple table" >
                      <TableHead>
                        <TableRow className="">
                          {
                            tableHeaders.map((item, index) => {
                              return <TableCell className="!tracking-widest lg:!text-lg bg-slate-400 !text-[#fff] text-[weight:bold] max-lg:!p-2"
                              align={index === 0 ? 'inherit' : 'center'}>
                                {item}
                              </TableCell>
                            })
                          }
                          <TableCell padding="checkbox" className="tracking-wide bg-slate-400 !text-[#fff] font-bold sticky right-0 max-lg:!p-2">

                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          tableData.map((row, index) => {
                            return <TableRow className={`even:bg-cyan-100`}>
                              {
                                tableHeaders.map((headerName, headerIndex) => {
                                  return <>
                                    {
                                      headerIndex === 0 ?
                                        <TableCell className={`!text-sm lg:!text-md max-lg:!p-2`} component="th" scope="row">
                                          {row[headerName]}
                                        </TableCell> :
                                        <TableCell className={`max-lg:!p-2`} align="center">{row[headerName]}</TableCell>
                                    }
                                  </>
                                })
                              }
                              <TableCell className={
                                `sticky right-0 bg-[#fdfdfdc8] max-md:shadow-[0px_0px_10px_10px_#000]`
                                //  +
                                // `sm:before:content-[] sm:before:absolute sm:before:h-full sm:before:w-1px sm:before:top-0 sm:before:left-0 sm:before:z-10 sm:before:shadow-[0px_0px_10px_10px_#000]`
                              }>
                                <EditIcon
                                  className={`cursor-pointer`}
                                  onClick={e => handleEditClick(row)}
                                />
                              </TableCell>
                            </TableRow>
                          })
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
            )

          }
          <Modal
            data={editData}
            open={modalOpen}
            handleOk={handleEditOk}
            handleCancel={handleEditCancel}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default Upload;